// extracted by mini-css-extract-plugin
export default {"contentBlock":"ContentBlock_contentBlock__fcrHp","hasMargin":"ContentBlock_hasMargin__BNlM4"};